var _circle, _circle2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTargetLevel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.83333,
    r: 1.5,
    stroke: "#525252"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.83333,
    r: 4.16667,
    stroke: "#525252"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 1,
    height: 3,
    fill: "#525252"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.33333,
    width: 1,
    height: 3,
    fill: "#525252"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.33333,
    width: 1,
    height: 3,
    transform: "rotate(90 3 5.33333)",
    fill: "#525252"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6.33333,
    width: 1,
    height: 3,
    transform: "rotate(-90 8 6.33333)",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTargetLevel);
export default __webpack_public_path__ + "static/media/icon_target_level.5ddcffe5553aa509c85316bb19152411.svg";
export { ForwardRef as ReactComponent };